import { render } from "./browse.vue?vue&type=template&id=0a4f9928&scoped=true"
import script from "./browse.vue?vue&type=script&lang=js"
export * from "./browse.vue?vue&type=script&lang=js"

import "./browse.vue?vue&type=style&index=0&id=0a4f9928&lang=scss&scoped=true"
import "./browse.vue?vue&type=style&index=1&id=0a4f9928&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4f9928"]])

export default __exports__